<div class="main-page">
  <div class="desktop-nav-bar">
    <ng-container *ngTemplateOutlet="DesktopNavBar"></ng-container>
  </div>
  <div class="flex-container">
    <filter-chip
      class="mobile-nav-bar"
      *ngIf="categoryList"
      [list]="categoryList"
    ></filter-chip>
    <div class="result-header" *ngIf="productList && productList?.length > 0">
      <shared-button
        color="primary"
        [variant]="'default'"
        icon="/assets/images/icons/sort-alt.svg"
        mode="dropdown"
        [dropdownOptions]="dropdownOptions"
      >
        <ng-container *ngIf="!selectedSortLabel">Sort By</ng-container>
        <ng-container *ngIf="selectedSortLabel">{{
          selectedSortLabel
        }}</ng-container>
      </shared-button>
      <div class="header-info">
        <p *ngIf="resultCount" class="header-info-text">
          Result Found: <span class="text-bold">{{ resultCount }}</span>
        </p>
      </div>
    </div>
    <div class="grid-container">
      <p
        class="empty-list-text"
        *ngIf="productList && productList.length === 0"
      >
        {{ 'categoryPage.emptyList' | translate }}
      </p>
      <ng-container *ngIf="productList && productList.length > 0">
        <div class="product-card" *ngFor="let product of productList">
          <shared-product-card [product]="product"></shared-product-card>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #DesktopNavBar>
  <div class="desktop-nav-bar">
    <h3 class="nav-bar-title">Categories:</h3>
    <div class="nav-list">
      <a *ngFor="let item of categoryList" [routerLink]="[item.url]">
        <div class="item-container" [ngClass]="{ active: item.isActive }">
          <div class="icon-co">
            <img [src]="item.avatar" [alt]="item.label" />
          </div>
          <p class="item-name">{{ item.label }}</p>
        </div>
      </a>
    </div>
  </div>
</ng-template>
